import React from 'react';
import { Field } from 'react-final-form';
import classNames from 'classnames';
import ValidationError from '../ValidationError/ValidationError';
import css from './FieldSwitchesGroup.module.css';

const FieldSwitchesGroup = props => {
    const {
        className,
        id,
        name,
        label,
        options,
        validate,
    } = props;

    return <Field id={id} name={name} validate={validate}>
        {({ input, meta }) => {
            const valueArray = Array.isArray(input.value) ? input.value : [];

            const handleChange = (optionValue) => {
                const nextValue = valueArray.includes(optionValue)
                    ? valueArray.filter(v => v !== optionValue)
                    : [...valueArray, optionValue];

                input.onChange(nextValue);
            };

            return <div className={classNames(css.toggleSwitchGroup, className)}>
                {label ? <legend>{label}</legend> : null}
                {options.map(option => {
                    const checked = valueArray.includes(option.key);

                    return <label key={option.key} className={css.toggleSwitch}>
                        <input
                            type="checkbox"
                            checked={checked}
                            onChange={() => handleChange(option.key)}
                            onBlur={input.onBlur}
                            onFocus={input.onFocus}
                        />
                        <span className={css.slider} />
                        <span className={css.labelText}>{option.label}</span>
                    </label>
                })}

                <ValidationError fieldMeta={meta} useDirty={true} />
            </div>
        }}
    </Field>
};

export default FieldSwitchesGroup;
